<template>
    <div class="story-maker-sticker story-maker-sticker-gif">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div class="sticker-gif">
           <img 
            
            class="selectDisable" 
            :class="parseInt(gif.images.original.heigth) > parseInt(gif.images.original.width) ? 'set-width' : 'set-height'"
            draggable="false" 
            data-check-load 
            :src="gif.images.original.url"
           >
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: Number | String,
            gif: Object,
        },
    }
</script>
